import googleDrive from '@cognitoforms/shared-components/src/assets/graphics/images/google-drive.svg';
import oneDrive from '@cognitoforms/shared-components/src/assets/graphics/images/microsoft-onedrive.svg';

export type CloudStorageProviderId = 'GoogleDrive' | 'OneDrive'

export interface CloudStorageProvider {
	id: CloudStorageProviderId;
	name: string;
	icon: string;
}

export const CloudStorageProviders: CloudStorageProvider[] = [
	{ id: 'GoogleDrive', name: 'Google Drive', icon: googleDrive },
	{ id: 'OneDrive', name: 'OneDrive', icon: oneDrive }
];
